import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import SelectBoxWithLabel from "../components/SelectBoxWithLabel";
import Axios from "axios";
import getAxiosConfig from "../../../utils/axiosConfig";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import {showToastForBackend} from "../../../actions/toastActions";
import SelectBox from "../components/SelectBox";
import CheckBox from "../components/CheckBox";
import InputWithLabel from "../components/InputWithLabel";
import ContentWithTopLabel from "../components/ContentWithTopLabel";
import ToggleMaxResultBox from '../components/ToggleMaxResultBox';
import PanelLayout from "../components/PanelLayout";


class AlgorithmPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            predictors: [],
            itemProperties: [],
            algorithmOptions: {
                predictorContextItemsPropertyName: this.props.contextProperties.length > 0 ? this.props.contextProperties[0].name : "",
                predictorContextUserPropertyName: this.props.contextProperties.length > 0 ? this.props.contextProperties[0].name : "",
                predictorName: "",
                isContextItemsPropertyNameSelected: false,
                isContextUserPropertyNameSelected: false,
                outputDynamicPropertyName: "",
                settings: {}
            },
            selectedTab: "NodeDetail"
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
        this.changeTab = this.changeTab.bind(this);
        this.updateSettings = this.updateSettings.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.algorithmOptions && this.props.clickedNodeInfo.extras.options.algorithmOptions.predictorName !== null) {
            this.setState({algorithmOptions: this.props.clickedNodeInfo.extras.options.algorithmOptions}, () => {
                this.updateOptions();
            });
        } else {
            this.updateOptions();
        }
        //For SelectBox component
        let config = getAxiosConfig();
        config["params"] = {firstBlock: false};
        Axios.get(this.props.properties.logicUrl + "/predictors", config)
            .then(predictorList => {
                let predictorListSorted = predictorList.data.sort(
                    (a, b) => a.readableName > b.readableName ? 1 : -1
                );
                if (this.state.algorithmOptions.predictorName === "") {
                    this.setState(prevState => ({
                        predictors: predictorListSorted,
                        algorithmOptions: {
                            ...prevState.algorithmOptions,
                            predictorName: predictorListSorted[0].predictorName
                        }
                    }), () => {
                        this.updateOptions();
                    });
                } else {
                    this.setState({predictors: predictorListSorted});
                }
            })
            .catch(err => {
                if (err.response) {
                    this.props.showToastForBackend(err.response.data);
                }
            });
    }

    updateOptions() {
        const algorithmOptions = this.state.algorithmOptions;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let panelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(panelInfo.extras, "options")) {
            panelInfo.extras.options = {};
        }
        panelInfo.extras.options.algorithmOptions = algorithmOptions;
        this.props.clickedNodeAction(panelInfo);
    }

    updateSettings(property, value) {
        this.setState(prevState => ({
            algorithmOptions: {
                ...prevState.algorithmOptions,
                settings: {
                    ...prevState.algorithmOptions.settings,
                    [property]: value
                }
            }
        }), () => {
            this.updateOptions();
        });
    }

    handleChange(property, value) {
        this.setState(prevState => ({
            algorithmOptions: {
                ...prevState.algorithmOptions,
                [property]: value
            }
        }), () => {
            this.updateOptions();
        });
    }

    changeTab(event) {
        this.setState({selectedTab: event.currentTarget.dataset.id});
    }

    render() {
        const displaySettingAccordingToType = (settingValue, name, property) => {
            if (settingValue.type === "CONTEXT_PARAMETER") {
                return <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value)}
                                    selectValue={this.state.algorithmOptions.settings[property] !== undefined ? this.state.algorithmOptions.settings[property] : ""}
                                    selectArray={this.props.contextProperties.sort(
                                        (a, b) => a.name > b.name ? 1 : -1
                                    ).map(function (contextProperty) {
                                        return {label: contextProperty.name, value: contextProperty.name}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "OPTIONS") {
                return <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value)}
                                    selectValue={this.state.algorithmOptions.settings[property] !== undefined ? this.state.algorithmOptions.settings[property] : ""}
                                    selectArray={settingValue.options.sort(
                                        (a, b) => a.optionReadableName > b.optionReadableName ? 1 : -1
                                    ).map(function (option) {
                                        return {label: option.optionReadableName, value: option.optionid}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "ITEM_PROPERTY") {
                return <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="rule-container padded right-section entire">
                                <span className="select-label">{name}:</span>
                                <SelectBox
                                    handleChangeSelect={(event) => this.updateSettings(property, event.target.value)}
                                    selectValue={this.state.algorithmOptions.settings[property] !== undefined ? this.state.algorithmOptions.settings[property] : ""}
                                    selectArray={this.state.itemProperties.sort(
                                        (a, b) => a > b ? 1 : -1
                                    ).map(function (itemProperty) {
                                        return {label: itemProperty, value: itemProperty}
                                    })}
                                    showDefault={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
            if (settingValue.type === "CONSTANT") {
                return <div className="filter-group">
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <InputWithLabel label={name + ":"}
                                            handleChange={(event) => this.updateSettings(property, event.target.value)}
                                            value={this.state.algorithmOptions.settings[property] !== undefined ? this.state.algorithmOptions.settings[property] : ""}
                            />
                        </div>
                    </div>
                </div>
            }
        };
        const selectedPredictors = this.state.predictors.filter(predictor => predictor.predictorName === this.state.algorithmOptions.predictorName);
        return (
            <PanelLayout>
                <SelectBoxWithLabel
                    selectValue={this.state.algorithmOptions.predictorName}
                    selectArray={this.state.predictors.map(function (predictor) {
                        return {label: predictor.readableName, value: predictor.predictorName}
                    })}
                    handleChangeSelect={(event) => {
                        this.handleChange("predictorName", event.target.value);
                    }}
                    label="Predictor Type"/>
                <CheckBox
                    isSelected={this.state.algorithmOptions.isContextItemsPropertyNameSelected}
                    toggleInput={() => this.handleChange("isContextItemsPropertyNameSelected", !this.state.algorithmOptions.isContextItemsPropertyNameSelected)}
                    label="Item to Item Recommendation">
                    <div className="rule-container padded right-section">
                        <span className="select-label">Item Id Context Property:</span>
                        <SelectBox
                            handleChangeSelect={(event) => this.handleChange("predictorContextItemsPropertyName", event.target.value)}
                            selectValue={this.state.algorithmOptions.predictorContextItemsPropertyName}
                            selectArray={this.props.contextProperties.sort(
                                (a, b) => a.name > b.name ? 1 : -1
                            ).map(function (contextProperty) {
                                return {label: contextProperty.name, value: contextProperty.name}
                            })}/>
                    </div>
                </CheckBox>
                <CheckBox
                    isSelected={this.state.algorithmOptions.isContextUserPropertyNameSelected}
                    toggleInput={() => this.handleChange("isContextUserPropertyNameSelected", !this.state.algorithmOptions.isContextUserPropertyNameSelected)}
                    label="Item to User Recommendation">
                    <div className="rule-container padded right-section">
                        <span className="select-label">User Id Context Property:</span>
                        <SelectBox
                            handleChangeSelect={(event) => this.handleChange("predictorContextUserPropertyName", event.target.value)}
                            selectValue={this.state.algorithmOptions.predictorContextUserPropertyName}
                            selectArray={this.props.contextProperties.sort(
                                (a, b) => a.name > b.name ? 1 : -1
                            ).map(function (contextProperty) {
                                return {label: contextProperty.name, value: contextProperty.name}
                            })}/>
                    </div>
                </CheckBox>
                {selectedPredictors.length > 0 && selectedPredictors[0].possibleSettings.map((setting) => {
                    return displaySettingAccordingToType(setting.settingValue, setting.settingName.readableName, setting.settingName.id)
                })}
                <ContentWithTopLabel label="Output Score Name">
                    <InputWithLabel label="Output Dynamic Property Name:"
                                    handleChange={event => this.handleChange("outputDynamicPropertyName", event.target.value)}
                                    value={this.state.algorithmOptions.outputDynamicPropertyName}
                    />
                </ContentWithTopLabel>
                <ToggleMaxResultBox/>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        properties: state.properties,
        clickedNodeInfo: state.clickedNodeInfo,
        contextProperties: state.contextProperties
    }
}

export default connect(mapStateToProps, {hideModal, showToastForBackend, clickedNodeAction})(AlgorithmPanel);